import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "projects/packcert-web/src/environments/environment";

@Injectable()
export class ExpedicionesService {
  constructor(private readonly _http: HttpClient) {}

    // Común en Expediciones y Certificados
    public getExpedicionesConfeccionesDetail(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/CertificadoExpedicion/GetAllExpedicionesConFiltro', filters);
    }

    public deleteCertificadoExpedicion(id) {
        return this._http.delete<any>(environment.apiEndpoint + '/CertificadoExpedicion?id=' + id);
    }

    public getCertificadoPdf(id) {
        return this._http.get<any>(environment.apiEndpoint + '/CertificadoExpedicion/GeneraPDFCertificadoExpedicion?certificadoId=' + id);
    }

    public signCertificadoPdf(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/CertificadoExpedicion/FirmaCertificadoExpedicion', filters);
    }

    public getDocHelp(nombreArchivo: string) {
        return this._http.get<any>(environment.apiEndpoint + '/Utilities/GetDocHelp/?nombreArchivo=' + nombreArchivo);
    }
    
    // MANTENIMIENTO EXPEDICIONES
    public getConfecciones(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Consumo/GetAllExpedicionesConfeccion', filters);
    }

    public getDenominacionesByPais(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Denominacion/GetAllConFiltro', filters);
    }

    public getCampanyasByPaisDenominacion(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Campanya/GetAllConFiltro', filters);
    }

    public getEtiquetadores(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Etiquetador/GetAllConFiltro', filters);
    }

    public getAlmacenesByEtiquetador(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Almacen/GetAllConFiltro', filters);
    }

    public getConfeccionesByEtiquetador(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Confeccion/GetAllConFiltro', filters);
    }

    public createExpedicion(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/CertificadoExpedicion', filters);
    }

    public getExpedicionById(id) {
        return this._http.get<any>(environment.apiEndpoint + '/CertificadoExpedicion/GetById?certificadoId=' + id);
    }

    public updateExpedicion(filters) {
        return this._http.put<any>(environment.apiEndpoint + '/CertificadoExpedicion', filters);
    }

    public getExpediciones(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/CertificadoExpedicion/GetAllExpedicionesExpedicion', filters);
    }

    // CERTIFICADOS
    public getCertificados(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/CertificadoExpedicion/GetAllConFiltro', filters);
    }

    public getEstadosCertificado(filters) {
        return this._http.post<any>(environment.apiEndpoint + "/CertificadoExpedicion/GetAllEstadoHistByCertificadoExpedicionId", filters);
    }

    public updateCertificadoEstadoObservacion(filters) {
        return this._http.put<any>(environment.apiEndpoint + "/CertificadoExpedicion/UpdateCertificadoExpedicionEstadoHist", filters);
    }

    public updateEstadosCertificado(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/CertificadoExpedicion/UpdateEstadoCertificadoExpedicion', filters);
    }

    // TRAZABILIDAD CERTIFICADO 
    public getTrazabilidadCertificado(numCertificado) {
        return this._http.get<any>(environment.apiEndpoint + '/CertificadoExpedicion/GetTrazabilidadCertificadoByNCertificadoExpedicion?nCertificadoExpedicion=' + numCertificado);
    }
} 
